import { useState, Fragment } from 'react';
import { Button, Box, Skeleton } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useCustomersForCurrentUser, mutateCurrentUserCustomer } from '../../api/swrcurrentusercontext.js';
import { AutocompleteElement } from 'react-hook-form-mui';
import { useForm } from 'react-hook-form-mui';
import { FormContainer } from 'react-hook-form-mui';
import UserProfileContext from '../../context/userprofilecontext.js';
import { useContext } from 'react';


function getCustomerValue(customerID, displayName) {
  return { id: customerID, label: displayName }
}

function getCustomerDisplayName(customer) {
  // Organization customers have orgName, User customers have firstName/lastName
  if (customer.orgName) {
    return customer.orgName;
  }
  const first = customer.firstName || '';
  const last = customer.lastName || '';
  return `${first} ${last}`.trim() || customer.customerID;
}

function getCustomerValues(data, currentCustomerID) {
  const values = data.map((record) => {
    return getCustomerValue(record.customerID, getCustomerDisplayName(record));
  });
  return { values: values };
}

export default function SelectCurrentCustomerDialog(props) {

  const parentOnSubmit = props.onSubmit ? props.onSubmit : () => { };
  const parentOnCancel = props.onCancel ? props.onCancel : () => { };
  const title = props.title ? props.title : "Select Current Customer";

  const userProfileContext = useContext(UserProfileContext);
  const userCustomers = useCustomersForCurrentUser();

  const currentCustomer = userProfileContext.userProfile.currentCustomer;
  const currentDisplayName = currentCustomer ? getCustomerDisplayName(currentCustomer) : '';

  const defaultValues = {
    "current_customer": currentCustomer
      ? getCustomerValue(currentCustomer.customerID, currentDisplayName)
      : null
  };

  const [values, setValues] = useState(defaultValues);

  const formContext = useForm({
    defaultValues: defaultValues, values
  });

  const { handleSubmit, setValue } = formContext;

  const handleCancel = () => {
    parentOnCancel();
  };

  const onSubmit = (data) => {
    const newCustomerID = data.current_customer.id;
    setValues(data);
    mutateCurrentUserCustomer(newCustomerID);
    parentOnSubmit(data);
  };

  if (userProfileContext.isLoading || userCustomers.isLoading || !userCustomers.data || userCustomers.data.length === 0) {
    return (
      <Fragment>
        <Dialog open={props.open} onClose={handleCancel}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Skeleton variant="rectangular" sx={{ minWidth: 500, minHeight: 300 }} />
          </DialogContent>
        </Dialog>
      </Fragment>
    );
  }

  let options = [];
  if (userCustomers.data.length > 0) {
    const customers = getCustomerValues(userCustomers.data, currentCustomer?.customerID);
    options = customers.values;
  }

  return (
    <Fragment>
      <Dialog open={props.open} onClose={handleCancel}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent sx={{ p: 2, minWidth: 500, minHeight: 300 }}>
          <FormContainer values={values} defaultValues={defaultValues} formContext={formContext} handleSubmit={handleSubmit}>
            <Box sx={{ pt: 1 }}>
              <AutocompleteElement name="current_customer" options={options} setValue={setValue} label="Current Customer" required />
            </Box>
            <Button
              style={{ margin: "10px 0px", maxWidth: "75px" }}
              onClick={handleSubmit(onSubmit)} variant={"contained"}>
              Save
            </Button>
          </FormContainer>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}